"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _events = _interopRequireDefault(require("events"));
var _playerMethods = _interopRequireDefault(require("../constants/playerMethods"));
var _debugger = _interopRequireDefault(require("../../debugger"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var on = _playerMethods["default"].on,
  off = _playerMethods["default"].off,
  preload = _playerMethods["default"].preload,
  init = _playerMethods["default"].init,
  load = _playerMethods["default"].load,
  play = _playerMethods["default"].play,
  seek = _playerMethods["default"].seek,
  pause = _playerMethods["default"].pause,
  stop = _playerMethods["default"].stop,
  unload = _playerMethods["default"].unload,
  destroy = _playerMethods["default"].destroy,
  setVolume = _playerMethods["default"].setVolume,
  getVolume = _playerMethods["default"].getVolume,
  setTitle = _playerMethods["default"].setTitle,
  getTimes = _playerMethods["default"].getTimes,
  requestInstreamAds = _playerMethods["default"].requestInstreamAds;
var Player = exports["default"] = /*#__PURE__*/function (_EventEmitter) {
  (0, _inherits2["default"])(Player, _EventEmitter);
  function Player(playerName) {
    var _this;
    (0, _classCallCheck2["default"])(this, Player);
    _this = _callSuper(this, Player);
    _this.name = playerName;
    return _this;
  }
  (0, _createClass2["default"])(Player, [{
    key: on,
    value: function value() {
      throw new Error(on + ' must be defined on Player instance');
    }
  }, {
    key: off,
    value: function value() {
      throw new Error(off + ' must be defined on Player instance');
    }
  }, {
    key: preload,
    value: function value() {
      _debugger["default"].log(preload + ' not defined for Player instance');
    }
  }, {
    key: init,
    value: function value() {
      _debugger["default"].log(init + ' not defined for Player instance');
    }
  }, {
    key: load,
    value: function value() {
      throw new Error(load + ' must be defined on Player instance');
    }
  }, {
    key: play,
    value: function value() {
      throw new Error(play + ' must be defined on Player instance');
    }
  }, {
    key: seek,
    value: function value() {
      _debugger["default"].log(seek + ' not defined for Player instance');
    }
  }, {
    key: pause,
    value: function value() {
      throw new Error(pause + ' must be defined on Player instance');
    }
  }, {
    key: stop,
    value: function value() {
      throw new Error(stop + ' must be defined on Player instance');
    }
  }, {
    key: unload,
    value: function value() {
      throw new Error(unload + ' must be defined on Player instance');
    }
  }, {
    key: destroy,
    value: function value() {
      throw new Error(destroy + ' must be defined on Player instance');
    }
  }, {
    key: setVolume,
    value: function value() {
      throw new Error(setVolume + ' must be defined on Player instance');
    }
  }, {
    key: getVolume,
    value: function value() {
      throw new Error(getVolume + ' must be defined on Player instance');
    }
  }, {
    key: setTitle,
    value: function value() {
      throw new Error(setTitle + ' must be defined on Player instance');
    }
  }, {
    key: getTimes,
    value: function value() {
      throw new Error(getTimes + ' must be defined on Player instance');
    }
  }, {
    key: requestInstreamAds,
    value: function value() {
      _debugger["default"].log(requestInstreamAds + ' not defined for Player instance');
    }
  }]);
  return Player;
}(_events["default"]);
//# sourceMappingURL=Player.js.map